import { useEffect, useState } from "react";
import Categories from "../../Categories/Categories";
import styles from "./Sector.module.scss";
import dropdownIcon from "../../../assets/icons/accordian-down-blue.svg";
import useAnimationState from "../../../hooks/useAnimationStates";
import DropdownArrow from "../../DropdownArrow/DropdownArrow";
import { ReactComponent as AccordionDownBlue } from "../../../assets/icons/accordian-down-blue.svg";

function Sector(props) {
  const { setDelay, show, delay } = useAnimationState();
  return (
    <div>
      <span className={styles["sector-title"]} onClick={() => setDelay(!delay)}>
        <div className={styles["dropdown-margin"]}>
          <AccordionDownBlue
            stroke="var(--primaryColor)"
            style={
              !show
                ? {
                    transform: "rotate(270deg)",
                  }
                : {}
            }
          ></AccordionDownBlue>
        </div>
        {props.item && props.item.sector_name}
        {/*props.showSearchBox && (
          
        )*/}
      </span>
      {show && (
        <Categories
          data={props.item.categories}
          delay={delay}
          selectedServices={props.selectedServices}
          currentStep={props.currentStep}
          onServiceSelect={props.onServiceSelect}
          onServiceDeSelect={props.onServiceDeSelect}
        />
      )}
    </div>
  );
}

export default Sector;
